module.exports = __webpack_public_path__ + "static/img/plug11.6d87e7a5.png";